import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function SpinalInjuryView() {
  useDocumentTitle('Spinal injury-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb
        image={'bg-image-18'}
        title={'Spinal Injury'}
        link={'spinal-injury'}
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105 ">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                Specialist personalized care to meet your ongoing needs
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  People of all ages can suffer from spinal injuries, which can
                  result in a range of clinical treatment requirements.
                </p>
                <p className="values_p3">
                  Depending on the severity and type of injury sustained as well
                  as the specific care requirements, the care needed for someone
                  with a spinal injury can be complex and varied.
                </p>
                <p className="values_p3">
                  While some of our clients may be able to maintain their level
                  of independence by having a small care team assist them with
                  daily chores, others may need more involved interventions and
                  round-the-clock assistance.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/brain-injury">
                        Brain injury
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/how-we-deliver">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-care">
                        Our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Creating your bespoke care package
                </h2>
                <p className="white-color">
                  If necessary, we will collaborate with you, your family, and
                  multidisciplinary teams to design a customized package of care
                  that will address your clinical, social, and personal needs.
                </p>
                <p className="white-color">
                  At the beginning of your journey, we frequently collaborate
                  closely with acute settings and brain rehabilitation units to
                  ease your transition home.
                </p>
                <p className="white-color">
                  Along with the practical and clinical aspects of your care, we
                  take into account the social and emotional aspects of your
                  everyday life.
                </p>
                <p className="white-color">
                  We have a wealth of expertise providing care for people with
                  brain injuries, which has prepared us to assist our clients
                  and their families during a period that can be incredibly
                  difficult.
                </p>
                <h2 className="white-color">The way we support you</h2>
                <p className="white-color">
                  {' '}
                  Our highly trained healthcare assistants deliver the care we
                  provide in your own home. This care can include:
                </p>
                .
                <div>
                  <ul className="care_bullets">
                    <li>Bowel care, including manual evacuation.</li>
                    <li className="">Autonomic dysreflexia management.</li>
                    <li>Catheter care and maintenance.</li>
                    <li>Bladder wash.</li>
                    <li>Postural hypotension.</li>
                    <li>Mobility support</li>
                    <li>Percutaneous Endoscopic Gastrostomy (PEG)</li>
                    <li>
                      Physiotherapy rehabilitation working with prescribed
                      protocols.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">What a spinal injury is</h2>
                <p className="">
                  A spinal injury is damage to any portion of the spinal cord,
                  resulting in a loss of function such as mobility, strength,
                  sensation, and other bodily functions below the location of
                  the injury.
                </p>
                <p>
                  Our spinal cord's nerves transmit brain signals to the rest of
                  our body, thus, it can be thought of as an outgrowth of the
                  brain.
                </p>
                <p>
                  All of these signals give us the ability to move and regulate
                  essential bodily processes like respiration, blood pressure,
                  bladder control, and bowel movement. These signals can be
                  messed up if the spinal cord is injured in any manner, which
                  could affect any functions or sensations below the site of the
                  injury.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Types of spinal injuries</h2>
                <p className="white-color">
                  There are two main types of spinal injuries: complete and
                  incomplete.
                </p>
                <p className="white-color">
                  In an incomplete spinal injury, the signals sent from the
                  brain are not entirely lost. Because the spinal cord was not
                  completely destroyed or disrupted, a person who has
                  experienced an incomplete spinal injury does not have total
                  paralysis or lack of sensation. This indicates that movement
                  and sensation are still feasible below the site of the injury.
                </p>

                <p className="white-color">
                  There are three typical forms of incomplete spinal injuries:
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>
                      Anterior Cord Syndrome: Affects sensations of heat, pain,
                      and mild contact.
                    </li>
                    <li>
                      Central Cord Syndrome: a neck injury that leaves the arms
                      and hands without motion or feeling.
                    </li>
                    <li>
                      Brown-Sequard Syndrome: a rare condition that is brought
                      on by damage to one side of the spinal nerves and results
                      in loss of position, a light touch, and a vibration
                      sensation.
                    </li>
                  </ul>
                </div>
                <p className="white-color">
                  A complete spinal injury is much more severe, and any brain
                  signals below the injury site are entirely lost.
                </p>
                <p className="white-color">
                  There are three different kinds of complete spinal injuries:
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>
                      Tetraplegia, the most serious type of complete spinal
                      injury, can impair one's ability to breathe on their own
                      and cause a partial or complete loss of sensory and motor
                      function in both arms, legs and the torso
                    </li>
                    <li>
                      Paraplegia is a type of paralysis that affects both legs
                      in the lower half of the torso. Paraplegics will
                      experience movement issues and may need to use a
                      wheelchair.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default SpinalInjuryView;
